import { render, staticRenderFns } from "./Ldap.vue?vue&type=template&id=645fda9d&scoped=true"
import script from "./Ldap.vue?vue&type=script&lang=js"
export * from "./Ldap.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "645fda9d",
  null
  
)

export default component.exports